

<div>
  <button *ngIf="showCancel" mat-button class="celo-secondary-button button-hover thin-font" (click)="cancel.emit($event)" [ngClass]="alignment">
    Cancel
  </button>
  <button *ngIf="showSave" mat-button [disabled]="saveButtonDisabled" class="celo-primary-button button-hover" (click)="save.emit($event)" [ngClass]="alignment">
    Save
  </button>
</div>